export default "__VITE_ASSET__989abe2f__"